import type { AnalyticsEventHandler } from '@atlassian/navigation-drag-and-drop';
import {
	fireTrackAnalytics,
	useAnalyticsEvents,
	fireUIAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { LEVEL_TWO } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import { BOARD } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/item-type.tsx';
import { SECTION_ITEM_STARRED } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';

/* This hook provides a fireAnalyticsEvent function preconfigured for drag-and-drop reordering
   of boards within the project sidebar. It was created to be used in conjunction with
   useNestedItemDragAndDrop to provide analytics for drag-and-drop operations and was intended to
   avoid duplicating code between the StarredSectionWithFocusRestoration and DraggableBoardItem components. */

export const useDragAndDropReorderingAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const fireAnalyticsEvent: AnalyticsEventHandler = ({
		action,
		itemId,
		operation,
		successfulReorder,
	}) => {
		const analyticsEvent = createAnalyticsEvent({});
		const baseAttributes = {
			level: LEVEL_TWO,
			componentType: 'customItem',
			itemType: BOARD,
			section: SECTION_ITEM_STARRED,
			itemId,
		};
		if (action === 'updated') {
			fireTrackAnalytics(analyticsEvent, {
				action,
				actionSubject: 'sidebarNavigationItems',
				actionSubjectId: 'boardsNavigationMenuItem',
				attributes: {
					...baseAttributes,
					itemId,
					action: operation,
				},
			});
		} else {
			fireUIAnalytics(analyticsEvent, {
				action,
				actionSubject: 'navigationItem',
				attributes: {
					...baseAttributes,
					itemId,
					successfulReorder,
				},
			});
		}
	};
	return { fireAnalyticsEvent };
};
